export default "__VITE_ASSET__13e4e7f9__"